export default "__VITE_ASSET__CAmJg8Ey__"